import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogSaveCloseComponent } from './dialog-save-close.component';
import { AngularMaterialModule } from 'src/app/angular-material.module';

@NgModule({
  declarations: [DialogSaveCloseComponent],
  imports: [
    CommonModule,
    AngularMaterialModule
  ],
  exports: [DialogSaveCloseComponent]
})
export class DialogSaveCloseModule { }
